<template>
    <div class="m-auto text-center">
        <h3 style="margin-top:64px">{{message}}</h3>
    </div>
</template>
<script>
import { DataApi } from "../../../service/DataApi";
export default {
    
    data() {
        return {
            message: 'Maaf, anda tidak berhak melihat Data.',
        }
    },
    methods: {
        getFile() {
            let payload = {
                unix: this.$route.params.id,
                tipe: this.$route.params.tipe
            }
            DataApi.post("/export/pdf/qr", payload , {responseType: 'blob'})
            .then(res => {
                if(res.status == 200) {
                    let response = res.data
                    const url = URL.createObjectURL(new Blob([response], {
                        type: 'application/pdf'
                    }))
                    this.message = 'Data Berhasil di Lihat'
                    window.open(url)
                }
            })
        },
        goHome() {
            setTimeout(this.$router.replace("/pages/login"), 3000);
        },
    },
    mounted() {
        if(localStorage.getItem("token")) {
            this.getFile()
        } else {
            this.goHome()
        }
    }
}
</script>